module.exports = __webpack_public_path__ + "img/TechInfantryArm1_ua.48b0e304.webp";